module.exports = __webpack_public_path__ + "image-cca82c7041f7.png";